import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { useEffect } from 'react'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { ILibraryGroup } from '@/pages/Library/libraryGroups.types.ts'
import libraryGroupsApi from '@/pages/Library/libraryGroups.api.ts'
import libraryEvents from '@/pages/Library/events/library.events.ts'
import LibraryGroupDropdown from '@/pages/Library/components/LibraryGroupDropdown'
import useLibraryGroup from '@/pages/Library/hooks/useLibraryGroup.ts'

interface IProps {
  groupId: ILibraryGroup['id']
  open: boolean
  onClose: () => void
}

const UpdateLibraryGroupModal = (props: IProps) => {
  const { group } = useLibraryGroup(props.groupId)
  const { wait, loading } = useHttpLoader()
  const [draft, setDraft, handleChange] = useStateWithChange<ILibraryGroup>(group)

  useEffect(() => {
    setDraft(group)
  }, [group])

  const handleSave = () => {
    wait(libraryGroupsApi.updateGroup(draft), (resp) => {
      if (resp.status === 'success') {
        libraryEvents.updatedGroup(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Редактирование группы" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Вышестоящая группа">
          <LibraryGroupDropdown
            name="parentId"
            wrapperStyle={{ height: '32px' }}
            onChange={handleChange}
            value={draft.parentId}
            title="Выберите группу"
          />
        </FormField>
        <FormField label="Наименование группы" required>
          <TextInput name="name" onChange={handleChange} value={draft.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Сохранить" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default (props: IProps) => {
  if (!props.groupId) return null

  return <UpdateLibraryGroupModal {...props} />
}
